import { createContext } from 'react'

const drawerContext = createContext({
  handleActionSwipeDrawer: () => {},
  isSwipeableDrawer: false,
  openedDrawer: false,
})

export default drawerContext
